import React, { useEffect, useState } from "react";
import NavbarMoment from "../../../../components/NavbarMovement";
import CodeReaderField from "../../../../components/CodeReaderField";
import MovementTable from "../../../../components/MovementTable";
import Button from "../../../../components/Button";
import ConsumoMovement from "./consumo";
import ServicoMovement from "./servico";
import PerdaMovement from "./perda";
import EstoqueMovement from "./estoque";
import VendaMovement from "./venda";

import { fetchEstoqueOnce } from "../../Estoque/estoqueData";

type TableRow = {
  codigo: string;
  nomeProduto: string;
  quantidadeEstoque: number;
  quantidadeSelecionada: number;
};

type RowMeta = {
  productId: number;
  custoUnitarioDefault?: string | null;
};

type EstoqueItem = {
  posicao: string;
  codigo: string;
  ncm: string;
  nomeProduto: string;
  custoUnitario: number | string | null;
  quantidade: number;
  classificacao: string;
};

const RegistrarProduto: React.FC = () => {
  const headers: (keyof TableRow)[] = [
    "codigo",
    "nomeProduto",
    "quantidadeEstoque",
    "quantidadeSelecionada",
  ];
  const columnWidths = ["20px", "100px", "10px", "10px"];

  const [buscando, setBuscando] = useState(false);
  const [rows, setRows] = useState<TableRow[]>([]);
  const [rowMetaByCodigo, setRowMetaByCodigo] = useState<
    Record<string, RowMeta>
  >({});
  const [codigo, setCodigo] = useState("");

  const [selected, setSelected] = useState<
    "Serviço" | "Estoque" | "Perda" | "Consumo" | "Venda"
  >("Serviço");

  const moneyToNumber = (v?: string | null) => {
    if (v == null) return 0;
    const n = Number(String(v).replace(",", "."));
    return Number.isFinite(n) ? n : 0;
  };

  const calcularCustoTotal = () => {
    return rows.reduce((acc, r) => {
      const meta = rowMetaByCodigo[r.codigo];
      const unit = moneyToNumber(meta?.custoUnitarioDefault);
      return acc + unit * r.quantidadeSelecionada;
    }, 0);
  };

  // ---------- SERVIÇO ----------
  const [numeroOS, setNumeroOS] = useState("");
  const [nomeEmbarcacao, setNomeEmbarcacao] = useState("");
  const [responsavelLiberacao, setResponsavelLiberacao] = useState("");
  const [responsavelColeta, setResponsavelColeta] = useState("");
  const [nomeEmpresa, setNomeEmpresa] = useState("");
  const [empresaClienteId, setEmpresaClienteId] = useState<number | null>(null);

  const [coordenadoresResponsaveisIds, setCoordenadoresResponsaveisIds] =
    useState<number[]>([]);
  const [coordenadoresResponsaveisNomes, setCoordenadoresResponsaveisNomes] =
    useState<string[]>([]);

  // ---------- PERDA ----------
  const [perdaResponsavelRemocao, setPerdaResponsavelRemocao] = useState("");
  const [perdaMotivo, setPerdaMotivo] = useState("");

  // ---------- CONSUMO ----------
  const [consumoResponsavelColeta, setConsumoResponsavelColeta] = useState("");
  const [consumoMotivo, setConsumoMotivo] = useState("");

  // ---------- VENDA ----------
  const [vendaClienteNome, setVendaClienteNome] = useState("");
  const [vendaNomeEmbarcacao, setVendaNomeEmbarcacao] = useState("");
  const [vendaNumeroPV, setVendaNumeroPV] = useState("");

  // ---------- ESTOQUE ----------
  const [estoque, setEstoque] = useState<EstoqueItem[]>([]);
  const [loadingEstoque, setLoadingEstoque] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetchEstoqueOnce();
        if (!alive) return;

        const arr = Array.isArray((res as any)?.itens)
          ? (res as any).itens
          : [];

        const adaptados: EstoqueItem[] = arr.map((x: any) => ({
          posicao: x.posicao ?? "",
          codigo: x.codigo ?? "",
          ncm: x.ncm ?? "",
          nomeProduto: x.nomeProduto ?? x.nome ?? "",
          custoUnitario: x.custoUnitario ?? x.custo_unitario ?? null,
          quantidade: Number(x.quantidade ?? x.quantidade_atual ?? 0),
          classificacao: x.classificacao ?? "",
        }));

        setEstoque(adaptados);
      } catch (e) {
        console.error("Falha ao carregar estoque:", e);
      } finally {
        if (alive) setLoadingEstoque(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const renderMovementComponent = () => {
    switch (selected) {
      case "Serviço":
        return (
          <ServicoMovement
            nomeEmpresa={nomeEmpresa}
            setNomeEmpresa={(v) => setNomeEmpresa(v.toUpperCase())}
            empresaClienteId={empresaClienteId}
            setEmpresaClienteId={setEmpresaClienteId}
            numeroOS={numeroOS}
            setNumeroOS={(v) => setNumeroOS(v.toUpperCase())}
            nomeEmbarcacao={nomeEmbarcacao}
            setNomeEmbarcacao={(v) => setNomeEmbarcacao(v.toUpperCase())}
            responsavelLiberacao={responsavelLiberacao}
            setResponsavelLiberacao={(v) =>
              setResponsavelLiberacao(v.toUpperCase())
            }
            responsavelColeta={responsavelColeta}
            setResponsavelColeta={(v) => setResponsavelColeta(v.toUpperCase())}
            coordenadoresResponsaveisIds={coordenadoresResponsaveisIds}
            setCoordenadoresResponsaveisIds={setCoordenadoresResponsaveisIds}
            coordenadoresResponsaveisNomes={coordenadoresResponsaveisNomes}
            setCoordenadoresResponsaveisNomes={
              setCoordenadoresResponsaveisNomes
            }
          />
        );
      case "Estoque":
        return <EstoqueMovement />;
      case "Perda":
        return (
          <PerdaMovement
            responsavelRemocao={perdaResponsavelRemocao}
            setResponsavelRemocao={(v) =>
              setPerdaResponsavelRemocao(v.toUpperCase())
            }
            motivoPerda={perdaMotivo}
            setMotivoPerda={(v) => setPerdaMotivo(v.toUpperCase())}
          />
        );
      case "Consumo":
        return (
          <ConsumoMovement
            responsavelColeta={consumoResponsavelColeta}
            setResponsavelColeta={(v) =>
              setConsumoResponsavelColeta(v.toUpperCase())
            }
            motivoConsumo={consumoMotivo}
            setMotivoConsumo={(v) => setConsumoMotivo(v.toUpperCase())}
          />
        );
      case "Venda":
        return (
          <VendaMovement
            clienteNome={vendaClienteNome}
            setClienteNome={(v) => setVendaClienteNome(v.toUpperCase())}
            nomeEmbarcacaoVenda={vendaNomeEmbarcacao}
            setNomeEmbarcacaoVenda={(v) =>
              setVendaNomeEmbarcacao(v.toUpperCase())
            }
            numeroPV={vendaNumeroPV}
            setNumeroPV={(v) => setVendaNumeroPV(v.toUpperCase())}
          />
        );
      default:
        return null;
    }
  };

  const nowAsSql = () =>
    new Date().toISOString().slice(0, 19).replace("T", " ");

  const handleEnviarBuscarProduto = async () => {
    const code = codigo.trim().toUpperCase();
    if (!code || buscando) return;

    setBuscando(true);
    try {
      const resp = await fetch(
        `https://api.eva-googlemarine.com/departamentos/suprimentos/produtos/${encodeURIComponent(
          code
        )}`,
        { method: "GET" }
      );

      if (!resp.ok) {
        alert("Produto não encontrado ou erro na API.");
        return;
      }

      const json = await resp.json().catch(() => null);
      const produto = json?.data?.produto;
      const estoqueAtual = json?.data?.estoque_atual;
      const custos = Array.isArray(json?.data?.custos) ? json.data.custos : [];

      if (!json?.ok || !produto) {
        alert("Produto não encontrado.");
        return;
      }

      const custoDefault: string | null =
        (estoqueAtual?.custo_unitario_atual as string | undefined) ??
        (custos?.[0]?.custo_unitario as string | undefined) ??
        null;

      const novaLinha: TableRow = {
        codigo: String(produto.codigo || "").toUpperCase(),
        nomeProduto: String(produto.nome || "").toUpperCase(),
        quantidadeEstoque: Number(estoqueAtual?.quantidade_atual ?? 0),
        quantidadeSelecionada: 1,
      };

      setRows((prev) => {
        if (prev.some((r) => r.codigo === novaLinha.codigo)) {
          alert("Produto já está na tabela.");
          return prev;
        }
        return [...prev, novaLinha];
      });

      setRowMetaByCodigo((prev) => ({
        ...prev,
        [produto.codigo]: {
          productId: Number(produto.id),
          custoUnitarioDefault: custoDefault ?? null,
        },
      }));

      setCodigo("");
    } catch (e) {
      console.error(e);
      alert("Falha ao buscar o produto.");
    } finally {
      setBuscando(false);
    }
  };

  const handleFinalizarMovimentacao = async () => {
    if (!rows.length) {
      alert("Adicione pelo menos um produto.");
      return;
    }

    const invalidateProdutos = async () => {
      try {
        await fetch(
          "https://api.eva-googlemarine.com/departamentos/suprimentos/produtos/invalidate",
          {
            method: "POST",
            headers: { Accept: "application/json" },
          }
        );
      } catch (e) {
        console.warn("Falha ao invalidar produtos (ignorado):", e);
      }
    };

    try {
      const meResp = await fetch("https://api.eva-googlemarine.com/auth/me", {
        method: "GET",
        credentials: "include",
      });
      const meJson = await meResp.json().catch(() => null);
      const responsavelId: number | null = meJson?.sessao?.uid ?? null;
      if (!meJson?.ok || !responsavelId) {
        alert("Não foi possível identificar o usuário (auth/me).");
        return;
      }

      const now = nowAsSql();
      const itens = rows.map((r) => {
        const meta = rowMetaByCodigo[r.codigo];
        if (!meta)
          throw new Error(`Metadados ausentes para o código ${r.codigo}`);
        const custoUnitario = meta.custoUnitarioDefault ?? null;
        return {
          produto_id: meta.productId,
          quantidade_selecionada: r.quantidadeSelecionada,
          ...(custoUnitario ? { custo_unitario: custoUnitario } : {}),
          data_item: now,
        };
      });

      if (selected === "Serviço") {
        const custoTotal = calcularCustoTotal().toFixed(2);

        const payload: any = {
          responsavel_id: responsavelId,
          departamento_origem: "suprimentos",
          custo_total: custoTotal,
          itens,
          ...(numeroOS ? { os_numero: numeroOS.trim().toUpperCase() } : {}),
          ...(responsavelColeta
            ? { coletor_nome: responsavelColeta.trim().toUpperCase() }
            : {}),
          ...(nomeEmbarcacao
            ? { embarcacao: nomeEmbarcacao.trim().toUpperCase() }
            : {}),
          ...(nomeEmpresa
            ? { nomeEmpresa: nomeEmpresa.trim().toUpperCase() }
            : {}),
          ...(empresaClienteId != null
            ? { empresa_cliente_id: empresaClienteId }
            : {}),
          ...(coordenadoresResponsaveisIds.length > 0
            ? { coordenador_responsavel_ids: coordenadoresResponsaveisIds }
            : {}),
        };

        const resp = await fetch(
          "https://api.eva-googlemarine.com/movimentar-produtos-servico-v2",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(payload),
          }
        );
        const text = await resp.text();
        const json = (() => {
          try {
            return JSON.parse(text);
          } catch {
            return null;
          }
        })();

        if (!resp.ok || !json?.ok) {
          const msg = json?.erro || `Falha (${resp.status})`;
          alert(`Erro ao movimentar: ${msg}`);
          return;
        }

        await invalidateProdutos();
        alert(`Movimentação criada (id=${json.data?.movimentacao?.id ?? "?"})`);
      }

      if (selected === "Perda") {
        if (!perdaMotivo.trim()) {
          alert("Informe o motivo da perda.");
          return;
        }

        const custoTotal = calcularCustoTotal().toFixed(2);

        const payload = {
          responsavel_id: responsavelId,
          departamento_origem: "suprimentos",
          motivo: perdaMotivo.trim().toUpperCase(),
          custo_total: custoTotal,
          itens,
        };

        const resp = await fetch(
          "https://api.eva-googlemarine.com/movimentar-produtos-perda",
          { method: "POST", body: JSON.stringify(payload) }
        );
        const text = await resp.text();
        const json = (() => {
          try {
            return JSON.parse(text);
          } catch {
            return null;
          }
        })();

        if (!resp.ok || !json?.ok) {
          const msg = json?.erro || `Falha (${resp.status})`;
          alert(`Erro ao movimentar: ${msg}`);
          return;
        }

        await invalidateProdutos();
        alert(
          `Perda registrada (id=${
            json.data?.movimentacao?.id ?? "?"
          }) — custo_total R$ ${custoTotal}`
        );
      }

      if (selected === "Consumo") {
        if (!consumoResponsavelColeta.trim()) {
          alert("Informe o nome do responsável pela coleta.");
          return;
        }
        if (!consumoMotivo.trim()) {
          alert("Informe o motivo do consumo.");
          return;
        }

        const custoTotal = calcularCustoTotal().toFixed(2);

        const payload = {
          responsavel_id: responsavelId,
          departamento_origem: "suprimentos",
          coletor_nome: consumoResponsavelColeta.trim().toUpperCase(),
          motivo: consumoMotivo.trim().toUpperCase(),
          custo_total: custoTotal,
          itens,
        };

        const resp = await fetch(
          "https://api.eva-googlemarine.com/movimentar-produtos-consumo",
          { method: "POST", body: JSON.stringify(payload) }
        );
        const text = await resp.text();
        const json = (() => {
          try {
            return JSON.parse(text);
          } catch {
            return null;
          }
        })();

        if (!resp.ok || !json?.ok) {
          const msg = json?.erro || `Falha (${resp.status})`;
          alert(`Erro ao movimentar: ${msg}`);
          return;
        }

        await invalidateProdutos();
        alert(
          `Consumo registrado (id=${
            json.data?.movimentacao?.id ?? "?"
          }) — custo_total R$ ${custoTotal}`
        );
      }

      if (selected === "Venda") {
        if (!vendaClienteNome.trim()) {
          alert("Informe o Nome do Cliente.");
          return;
        }
        if (!vendaNumeroPV.trim()) {
          alert("Informe o Número da P.V.");
          return;
        }

        const custoTotal = calcularCustoTotal().toFixed(2);

        const payload = {
          responsavel_id: responsavelId,
          departamento_origem: "suprimentos",
          cliente_nome: vendaClienteNome.trim().toUpperCase(),
          proposta_venda: vendaNumeroPV.trim().toUpperCase(),
          embarcacao: (vendaNomeEmbarcacao || "").trim().toUpperCase() || "N/A",
          custo_total: custoTotal,
          itens,
        };

        const resp = await fetch(
          "https://api.eva-googlemarine.com/movimentar-produtos-venda",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(payload),
          }
        );
        const text = await resp.text();
        const json = (() => {
          try {
            return JSON.parse(text);
          } catch {
            return null;
          }
        })();

        if (!resp.ok || !json?.ok) {
          const msg = json?.erro || `Falha (${resp.status})`;
          alert(`Erro ao movimentar venda: ${msg}`);
          return;
        }

        await invalidateProdutos();
        alert(
          `Venda registrada (id=${
            json.data?.movimentacao?.id ?? "?"
          }) — custo_total R$ ${custoTotal}`
        );
      }

      setConsumoMotivo("");
      setConsumoResponsavelColeta("");
      setRows([]);
      setRowMetaByCodigo({});
      setNumeroOS("");
      setNomeEmbarcacao("");
      setResponsavelLiberacao("");
      setResponsavelColeta("");
      setPerdaMotivo("");
      setPerdaResponsavelRemocao("");
      setVendaClienteNome("");
      setVendaNomeEmbarcacao("");
      setVendaNumeroPV("");
      setNomeEmpresa("");
      setEmpresaClienteId(null);
      setCoordenadoresResponsaveisIds([]);
      setCoordenadoresResponsaveisNomes([]);
    } catch (e) {
      console.error("Falha ao finalizar movimentação:", e);
      alert("Falha ao finalizar movimentação.");
    }
  };

  return (
    <div>
      <NavbarMoment
        options={["Serviço", "Perda", "Consumo", "Venda"]}
        onSelect={(value) => setSelected(value as typeof selected)}
      />

      <CodeReaderField
        label=""
        value={codigo}
        onChange={(v) => setCodigo(v.toUpperCase())}
        onSubmit={handleEnviarBuscarProduto}
        placeholder="Digite ou escaneie o código do Produto (ex: PRD00101)"
        UpperCase={true}
      />

      {renderMovementComponent()}

      <MovementTable
        headers={headers}
        rows={rows}
        columnWidths={columnWidths}
        onUpdateRows={setRows}
      />

      <div style={{ display: "flex", gap: 8, padding: 0 }}>
        <Button
          text="Finalizar Movimentação"
          onClick={handleFinalizarMovimentacao}
          disabled={rows.length === 0}
        />
      </div>
    </div>
  );
};

export default RegistrarProduto;
